import React from 'react';
import IconNext from '../assets/images/play-circle.svg';
import IconRefresh from '../assets/images/refresh.svg';
import FacebookIcon from '../assets/images/facebook.svg';
import TwitterIcon from '../assets/images/twitter.svg';
import LinkedinIcon from '../assets/images/linkedin.svg';

function RoundResults(props) {
  let titleMessage = props.rounds[props.currentRound - 1].correct > 2 ? `Felicidades, ${props.username} eres toda una autoridad en el tema de Coronavirus`  : `Cuidado ${props.username}` ;
  let message = props.currentRound == 3 ? 'Comparte tus conocimientos' : props.rounds[props.currentRound - 1].correct > 2 
    ? 'Todos deberían seguir tus recomendaciones' : 'Debes informarte más sobre el tema';
  
  let points = props.currentRound == 3  
    ? props.challengePoints
    : props.rounds[props.currentRound - 1].points;
  let urlShare = window.location.href;
  return (
    <div className="round-results">
      <div className="round-results-message">
        { props.currentRound == 3 && 
          <p><strong>¡Felicidades {props.username}!</strong> <br />Seguro has aprendido algo nuevo sobre Covid-19. Sigue jugando y aprendiendo más.</p>
        }
        { props.currentRound != 3 &&
          <p>{titleMessage}</p>
        }
        <span>{message}</span>
      </div>
      <div className="round-results-point">
        <div>Obtuviste</div>
        <div className="points">{`${points} puntos`}</div>
      </div>
      <div className="rounds">
        <dl>
          <dt>Ronda 1</dt>
          <dd>{ props.rounds[0].stats.length ? `${props.rounds[0].correct}/5 respuestas correctas` : '?' }</dd>
          <dt>Ronda 2</dt>
          <dd>{ props.rounds[1].stats.length ? `${props.rounds[1].correct}/5 respuestas correctas` : '?' }</dd>
          <dt>Ronda 3</dt>
          <dd>{ props.rounds[2].stats.length ? `${props.rounds[2].correct}/5 respuestas correctas` : '?' }</dd>
        </dl>
      </div>
      {
        props.currentRound == 3 && 
          (
            <div className="social-share">
              <h4>Compartir en</h4>
              <a href={`https://www.facebook.com/sharer.php?u=${urlShare}`} className="social-icon">
                <img src={FacebookIcon} alt="facebook" />
              </a>
              <a href={`https://www.twitter.com/share?url=${urlShare}`} className="social-icon">
                <img src={TwitterIcon} alt="twitter" />
              </a>
              <a href={`https://www.linkedin.com/shareArticle?mini=true&url=${urlShare}`} className="social-icon">
                <img src={LinkedinIcon} alt="linkedin" />
              </a>
            </div>
          )
      }
      <div className="actions">
        { 
          props.currentRound == 3 && props.restart && 
            (
              <button type="button" className="btn btn-gameif" onClick={props.restartGame}>
                Volver a jugar
                <img className="icon" src={IconRefresh} alt="" />
              </button>
            )
        }
        { 
          props.currentRound == 3 && !props.restart && 
            (
              <button type="button" className="btn btn-gameif" onClick={props.restartGame}>
                Jugar
                <img className="icon" src={IconNext} alt="" />
              </button>
            )
        }
        { 
          props.currentRound < 3 && 
            (
              <button type="button" className="btn btn-gameif" onClick={props.toNextRound}>
                Siguiente Ronda
                <img className="icon" src={IconNext} alt="" />
              </button>
            )
        }
      </div>
    </div>
  );
}

export default RoundResults;